export const enrichWithRequestOptions = (event, requestOptions) => {
  if (!requestOptions) {
    return event;
  }
  const attributes = {
    // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
    ...(requestOptions.extraAnalyticsAttributes || {}),
    ...(event.attributes || {}),
    sourceComponent: requestOptions.sourceComponent,
    sourceContext: requestOptions.sourceContext
  };
  return {
    ...event,
    attributes
  };
};